import ExtendedTimePicker, {
  normalizeExtendedTime,
} from "@lhd/components/ExtendedTimePicker";
import { useEffect, useState } from "react";
import { ICommonFieldProps } from "../../../../interfaces";
import { Styles } from "./styled";

const ExtendedTimeEditCell = ({
  defaultValue,
  onChange,
  getDisabledTimeData,
  colDef,
}: ICommonFieldProps) => {
  const [value, setValue] = useState(() => normalizeExtendedTime(defaultValue));

  useEffect(() => {
    setValue(normalizeExtendedTime(defaultValue));
  }, [defaultValue]);

  return (
    <Styles>
      <ExtendedTimePicker
        className="input-field timer"
        value={value}
        disabledTime={getDisabledTimeData}
        extendedTimeHourCount={colDef.editInfo?.extendedTimeHourCount}
        onChange={(nextValue) => {
          setValue(nextValue);
          onChange?.(nextValue);
        }}
      />
    </Styles>
  );
};

export default ExtendedTimeEditCell;
